import React, { useState } from 'react';
import { SearchIcon, DownloadIcon, RefreshCwIcon } from 'lucide-react';
interface ActivityLog {
  id: string;
  timestamp: string;
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
  };
  action: string;
  section: string;
  description: string;
  objectId: string;
  details: {
    amount?: string;
  };
  ipAddress: string;
  userAgent: string;
}
export function ActivityLogs() {
  const [activityLogs] = useState<ActivityLog[]>(() => {
    const logs: ActivityLog[] = [];
    const now = new Date();
    const actions = [{
      type: 'created',
      section: 'Payments',
      desc: 'Payment created'
    }, {
      type: 'updated',
      section: 'Payments',
      desc: 'Payment updated'
    }, {
      type: 'deleted',
      section: 'Payments',
      desc: 'Payment deleted'
    }, {
      type: 'created',
      section: 'Customers',
      desc: 'Customer created'
    }, {
      type: 'updated',
      section: 'Customers',
      desc: 'Customer updated'
    }, {
      type: 'deleted',
      section: 'Customers',
      desc: 'Customer deleted'
    }, {
      type: 'created',
      section: 'Invoices',
      desc: 'Invoice created'
    }, {
      type: 'updated',
      section: 'Invoices',
      desc: 'Invoice updated'
    }, {
      type: 'approved',
      section: 'Bills',
      desc: 'Bill approved'
    }, {
      type: 'created',
      section: 'Refunds',
      desc: 'Refund created'
    }, {
      type: 'updated',
      section: 'Settings',
      desc: 'Settings updated'
    }, {
      type: 'created',
      section: 'Users',
      desc: 'User invited'
    }, {
      type: 'updated',
      section: 'Security',
      desc: 'Security settings updated'
    }];
    const realUsers = [{
      id: '1',
      name: 'Simon Lee',
      email: 'ahmed@bilabilamart.my',
      role: 'Owner'
    }, {
      id: '2',
      name: 'Sarah Tan',
      email: 'aishath@bilabilamart.my',
      role: 'Finance'
    }, {
      id: '3',
      name: 'Ahmad Rahman',
      email: 'ibrahim@bilabilamart.my',
      role: 'Operations'
    }];
    for (let i = 0; i < 80; i++) {
      const action = actions[Math.floor(Math.random() * actions.length)];
      const user = realUsers[Math.floor(Math.random() * realUsers.length)];
      const minutesAgo = Math.floor(Math.random() * 43200);
      const timestamp = new Date(now.getTime() - minutesAgo * 60000);
      logs.push({
        id: `log-${i + 1}`,
        timestamp: timestamp.toISOString(),
        user: {
          id: user.id,
          name: user.name,
          email: user.email,
          role: user.role
        },
        action: action.type,
        section: action.section,
        description: action.desc,
        objectId: `${action.section.toLowerCase()}_${Math.random().toString(36).substr(2, 9)}`,
        details: {
          amount: Math.random() > 0.5 ? `MYR ${(Math.random() * 1000).toFixed(2)}` : undefined
        },
        ipAddress: `${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
        userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36'
      });
    }
    return logs.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
  });
  const [logFilters, setLogFilters] = useState({
    search: '',
    dateRange: '7days',
    user: 'all',
    section: 'all'
  });
  const [logsPerPage, setLogsPerPage] = useState(25);
  const [currentLogPage, setCurrentLogPage] = useState(1);
  const users = [{
    id: '1',
    name: 'Simon Lee'
  }, {
    id: '2',
    name: 'Sarah Tan'
  }, {
    id: '3',
    name: 'Ahmad Rahman'
  }];
  const filteredLogs = activityLogs.filter(log => {
    if (logFilters.search && !log.description.toLowerCase().includes(logFilters.search.toLowerCase()) && !log.user.name.toLowerCase().includes(logFilters.search.toLowerCase())) return false;
    if (logFilters.user !== 'all' && log.user.id !== logFilters.user) return false;
    if (logFilters.section !== 'all' && log.section !== logFilters.section) return false;
    if (logFilters.dateRange !== 'all') {
      const logDate = new Date(log.timestamp);
      const now = new Date();
      const daysDiff = Math.floor((now.getTime() - logDate.getTime()) / (1000 * 60 * 60 * 24));
      if (logFilters.dateRange === '24h' && daysDiff > 1) return false;
      if (logFilters.dateRange === '7days' && daysDiff > 7) return false;
      if (logFilters.dateRange === '30days' && daysDiff > 30) return false;
    }
    return true;
  });
  const totalPages = Math.ceil(filteredLogs.length / logsPerPage);
  const paginatedLogs = filteredLogs.slice((currentLogPage - 1) * logsPerPage, currentLogPage * logsPerPage);
  const getRelativeTime = (timestamp: string) => {
    const now = new Date();
    const then = new Date(timestamp);
    const seconds = Math.floor((now.getTime() - then.getTime()) / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };
  return <div className="max-w-7xl mx-auto py-8 px-4" data-id="element-14447" data-mp="pxqk0uizv12e">
      <div className="mb-8" data-id="element-14448" data-mp="pwflb94eoji5">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-14449" data-mp="pvnv6dtkvdz9">Activity Logs</h1>
        <p className="text-gray-600" data-id="element-14450" data-mp="2mrlh5wiokzs1">
          View and track all user activities and system events
        </p>
      </div>

      <div className="space-y-6" data-id="element-14451" data-mp="2rqyan042553l">
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-14452" data-mp="2jnno80fj3v9f">
          <div className="bg-gray-50 px-6 py-4 border-b border-gray-200" data-id="element-14453" data-mp="2fn3ul6u5z9s1">
            <h3 className="text-md font-semibold text-gray-900 flex items-center gap-2" data-id="element-14454" data-mp="2fp6t6f9dub8d">
              <SearchIcon size={18} className="text-gray-600" data-id="element-14455" data-mp="2tkimci7w3tn6" />
              Filters
            </h3>
          </div>
          <div className="p-6 space-y-4" data-id="element-14456" data-mp="32na0ips5h3ii">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-14457" data-mp="32m8dro1rusky">
              <div data-id="element-14458" data-mp="2ymhqvvfd8wlp">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14459" data-mp="2ykwwq6wyrfod">
                  Search
                </label>
                <input type="text" placeholder="Search logs..." className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#E2231A] focus:border-transparent text-sm" value={logFilters.search} onChange={e => setLogFilters({
                ...logFilters,
                search: e.target.value
              })} data-id="element-14460" data-mp="3cf7axubc3rg6" />
              </div>
              <div data-id="element-14461" data-mp="3r01xb40k3gt1">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14462" data-mp="3qyqkkep4uyps">
                  Date Range
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.dateRange} onChange={e => setLogFilters({
                ...logFilters,
                dateRange: e.target.value
              })} data-id="element-14463" data-mp="3vx1wcuyznjan">
                  <option value="all" data-id="element-14464" data-mp="2yamcxnn04bkg">All Time</option>
                  <option value="24h" data-id="element-14465" data-mp="2ybwckh9i5rt7">Last 24 Hours</option>
                  <option value="7days" data-id="element-14466" data-mp="33ah4zuiij773">Last 7 Days</option>
                  <option value="30days" data-id="element-14467" data-mp="33c21vqsav284">Last 30 Days</option>
                </select>
              </div>
              <div data-id="element-14468" data-mp="3eqneol6ncrpq">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14469" data-mp="3eq3zhc8dshfe">
                  User
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.user} onChange={e => setLogFilters({
                ...logFilters,
                user: e.target.value
              })} data-id="element-14470" data-mp="39q952yped9pl">
                  <option value="all" data-id="element-14471" data-mp="2qyoqj0m3n1v6">All Users</option>
                  {users.map(u => <option key={u.id} value={u.id} data-id="element-14472" data-mp="2lzve7bijtgwl">
                      {u.name}
                    </option>)}
                </select>
              </div>
              <div data-id="element-14473" data-mp="2c4bsfhxp7ylk">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14474" data-mp="2c5v8p8jcu9nc">
                  Section
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logFilters.section} onChange={e => setLogFilters({
                ...logFilters,
                section: e.target.value
              })} data-id="element-14475" data-mp="26yol02knfib2">
                  <option value="all" data-id="element-14476" data-mp="1o98dgvajqpl5">All Sections</option>
                  <option value="Payments" data-id="element-14477" data-mp="1t7te2vtpnba4">Payments</option>
                  <option value="Customers" data-id="element-14478" data-mp="1t5gpw0xd04om">Customers</option>
                  <option value="Invoices" data-id="element-14479" data-mp="1xzbhrrn4bpys">Invoices</option>
                  <option value="Bills" data-id="element-14480" data-mp="10ivxqy927ok0">Bills</option>
                  <option value="Refunds" data-id="element-14481" data-mp="10i2xmg4lvxau">Refunds</option>
                  <option value="Users" data-id="element-14482" data-mp="15hpb8qocjfk6">Users</option>
                  <option value="Settings" data-id="element-14483" data-mp="15g4klc55kgrl">Settings</option>
                  <option value="Security" data-id="element-14484" data-mp="9hkg0q2dw6j7">Security</option>
                </select>
              </div>
              <div data-id="element-14485" data-mp="ef2q4js50rss">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-14486" data-mp="eeawhei3p455">
                  Per Page
                </label>
                <select className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#EB4A42] focus:border-transparent text-sm" value={logsPerPage} onChange={e => {
                setLogsPerPage(Number(e.target.value));
                setCurrentLogPage(1);
              }} data-id="element-14487" data-mp="jd4bxcgy757y">
                  <option value="25" data-id="element-14488" data-mp="3vu9a9anwvxmn">25</option>
                  <option value="50" data-id="element-14489" data-mp="4hy20eeqem9c">50</option>
                  <option value="100" data-id="element-14490" data-mp="4jss074v14ka">100</option>
                </select>
              </div>
            </div>
            <div className="flex items-center justify-between pt-2" data-id="element-14491" data-mp="343d5yyfx31az">
              <p className="text-sm text-gray-600" data-id="element-14492" data-mp="38588g69l3kqc">
                Showing {paginatedLogs.length} of {filteredLogs.length} logs
              </p>
              <div className="flex gap-2" data-id="element-14493" data-mp="2vof9wi2udouk">
                <button className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-14494" data-mp="2vop0a6rsty0s">
                  <RefreshCwIcon size={14} data-id="element-14495" data-mp="2mmft9qvqoms5" />
                  Refresh
                </button>
                <button className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-14496" data-mp="2hpfve391mqc4">
                  <DownloadIcon size={14} data-id="element-14497" data-mp="27xtcrludlozc" />
                  Export
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-14498" data-mp="23uws7pl9zisr">
          <div className="overflow-x-auto" data-id="element-14499" data-mp="1yx4vmi9or8i8">
            <table className="w-full" data-id="element-14500" data-mp="1tya5swdawjom">
              <thead className="bg-gray-50 border-b border-gray-200" data-id="element-14501" data-mp="1tzbui3n8p4ot">
                <tr data-id="element-14502" data-mp="1kay3o97jqvz2">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14503" data-mp="1kaejelufbvhv">
                    Timestamp
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14504" data-mp="1adjmu8hpo568">
                    User
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14505" data-mp="1fe7gz318l24o">
                    Action
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14506" data-mp="27zh2zz8mbyf0">
                    Section
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14507" data-mp="1yah0w6ytkmwl">
                    Object ID
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-14508" data-mp="2lygt7bbs4lda">
                    IP Address
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white" data-id="element-14509" data-mp="f9yby2ab2gbi">
                {paginatedLogs.map(log => <tr key={log.id} className="hover:bg-gray-50 transition-colors" data-id="element-14510" data-mp="p1uje3ya7ise">
                    <td className="px-6 py-4 text-sm text-gray-900" title={new Date(log.timestamp).toLocaleString()} data-id="element-14511" data-mp="k3jabvft9cb8">
                      {getRelativeTime(log.timestamp)}
                    </td>
                    <td className="px-6 py-4" data-id="element-14512" data-mp="5emu3b3loszj">
                      <div className="flex items-center gap-2" data-id="element-14513" data-mp="5fg2shm4dskb">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-xs font-semibold" data-id="element-14514" data-mp="1c9wj9z0c1du">
                          {log.user.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div data-id="element-14515" data-mp="283y4dalh2wjs">
                          <p className="text-sm font-medium text-gray-900" data-id="element-14516" data-mp="2c36wkb0v6md8">
                            {log.user.name}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-14517" data-mp="2h0yp979c2cih">
                            {log.user.role}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-14518" data-mp="2qymwuxs1fei2">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-14519" data-mp="2v1j823f908bz">
                        {log.action}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600" data-id="element-14520" data-mp="34rma0t4ckwmg">
                      {log.section}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 font-mono" data-id="element-14521" data-mp="39pe0dipcgaoj">
                      {log.objectId}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600 font-mono" data-id="element-14522" data-mp="1338a1cblvqby">
                      {log.ipAddress}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50" data-id="element-14523" data-mp="o5pf1s8c4gw2">
              <button onClick={() => setCurrentLogPage(Math.max(1, currentLogPage - 1))} disabled={currentLogPage === 1} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-14524" data-mp="1lt6fdko0r5bw">
                Previous
              </button>
              <span className="text-sm text-gray-600" data-id="element-14525" data-mp="24l8rcipptxft">
                Page {currentLogPage} of {totalPages}
              </span>
              <button onClick={() => setCurrentLogPage(Math.min(totalPages, currentLogPage + 1))} disabled={currentLogPage === totalPages} className="px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-14526" data-mp="3u12y41tstcm4">
                Next
              </button>
            </div>}
        </div>
      </div>
    </div>;
}